import { queryOptions } from '@tanstack/react-query';

import { type DrillHoleQueryParams, drillHoleService } from '~api/services';

/**
 * Generate query options for fetching drill holes based on blast name and optional buffer distance
 * @param params - Query parameters including blast name and optional buffer distance
 * @returns Query options for fetching drill hole data
 */
function drillHolesQueryOptions(params: DrillHoleQueryParams) {
  return queryOptions({
    queryKey: ['drill_holes', params],
    queryFn: () => drillHoleService.getDrillHoles(params),
  });
}

export { drillHolesQueryOptions };
